import { useMemo } from 'react';
import { useAuth } from '../context/AuthContext';
import { COUNTRY_REGISTRY, DEFAULT_COUNTRY, CountryMetadata } from '../constants/countries';

/**
 * Hook to provide localization data (dial code, emergency numbers) based on user profile.
 */
export const useLocalization = () => {
  const { user } = useAuth();

  const currentCountry = useMemo((): CountryMetadata => {
    if (!user?.countryCode) return DEFAULT_COUNTRY;
    return COUNTRY_REGISTRY[user.countryCode.toUpperCase()] || DEFAULT_COUNTRY;
  }, [user?.countryCode]);

  const formatPhoneNumber = (phone: string) => {
    if (!phone) return '';
    // Si le numéro commence déjà par +, on ne rajoute rien
    if (phone.startsWith('+')) return phone;
    // Sinon on ajoute le dialCode du pays
    return `${currentCountry.dialCode}${phone}`;
  };

  return {
    currentCountry,
    emergency: currentCountry.emergencyNumbers,
    dialCode: currentCountry.dialCode,
    formatPhoneNumber
  };
};
